// A service name is one DNS label: the service is `<name>.<SERVICE_DOMAIN>`. The
// router checks names with the same pattern (config.NodeNameRegexp).
//
// `/access/:serviceName` takes the name from a link that anybody can make, and the
// page POSTs on arrival. So the app checks the name before any fetch or redirect
// (app#377, router#1768 RP-21): React Router decodes `%2F` to `/`, and a name such
// as `x/../../auth/logout` put raw into `/api/access/${name}/request` sends a
// credentialed POST to another router path. The same name in
// `https://${name}.${SERVICE_DOMAIN}` could send the browser to another host.
const SERVICE_NAME = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/

export const isServiceName = (name: string | null | undefined): name is string =>
  typeof name === 'string' && SERVICE_NAME.test(name)

// The router paths for one service, or null when the name is not a DNS label.
export const accessCheckURL = (routerBase: string, name: string): string | null =>
  isServiceName(name) ? `${routerBase}/api/access/${encodeURIComponent(name)}` : null

export const accessRequestURL = (routerBase: string, name: string): string | null =>
  isServiceName(name) ? `${routerBase}/api/access/${encodeURIComponent(name)}/request` : null

// The service's own address, or null when the name is not a DNS label.
export const serviceURL = (name: string, serviceDomain: string): string | null =>
  isServiceName(name) ? `https://${name.toLowerCase()}.${serviceDomain}` : null
